import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { FontManager } from "@/features/admin/components/font-manager";
import { PageContainer } from "@fleet/ui";

function AdminFontsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <FontManager />
    </PageContainer>
  );
}

interface AdminFontsSearch {
  q?: string;
}

export const adminFontsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/fonts",
  validateSearch: (raw: Record<string, unknown>): AdminFontsSearch => ({
    q: typeof raw.q === "string" && raw.q.trim() !== "" ? raw.q : undefined,
  }),
  component: AdminFontsPage,
});
